import { SortOrder } from '@/constants/request';
import { LIST_QUERY_CACHE_TTL_SECONDS, PROJECTS_LIST_TAG } from '@/api/constants';
import { api } from '@/api/core';
import { queryMockProjects } from './mockProjects';
import { mockDelay } from './mockUtils';
import type { ProjectVisibility } from './createProject';

export interface ProjectData {
  projectId: string;
  name: string;
  description: string | null;
  owner: string;
  /** The same id as the signed-in user's `userId`; only the owner may change the project's settings. */
  ownerId: string;
  team: string | null;
  visibility: ProjectVisibility;
  sharedWith: string[];
  numberOfFiles: number;
  lastModifiedDatetime: string;
}

export interface GetProjectsResponse {
  projects: ProjectData[];
  numberOfResults: number;
}

export type GetProjectsRequest = {
  pageIndex: number;
  pageSize: number;
  sortBy?: string;
  sortOrder?: SortOrder;
  search?: string;
  /** Each list matches any of its values; the lists and the search combine with AND. */
  owners?: string[];
  teams?: string[];
  visibilities?: ProjectVisibility[];
};

const MOCK_RESPONSE_DELAY_MS = 400;

const getProjectsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getProjects: builder.query<GetProjectsResponse, GetProjectsRequest>({
      // The backend `/projects` endpoint does not exist yet: serve mock data (see mockProjects.ts).
      queryFn: async (args, { getState }) => {
        await mockDelay(MOCK_RESPONSE_DELAY_MS);
        return { data: queryMockProjects(args, getState()) };
      },
      providesTags: (_result, _error, { pageIndex, pageSize }) => [
        { type: PROJECTS_LIST_TAG, id: `${pageIndex}-${pageSize}` },
      ],
      keepUnusedDataFor: LIST_QUERY_CACHE_TTL_SECONDS,
    }),
  }),
});

export const { useGetProjectsQuery } = getProjectsApi;
